import { IActivity } from '../models/Models';
import { produce } from 'immer';

const errorReducer = (state = {}, action: IActivity) => {
  return produce(state, (draft) => {
    const { type } = action;
    const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

    // not a *_REQUEST / *_SUCCESS /  *_FAILURE actions, so we ignore them
    if (!matches) return state;

    const [, requestName, requestState] = matches;

    // Store whether a request is happening at the moment or not
    // e.g. will be true when receiving GET_TODOS_FAILURE
    // and false when receiving GET_TODOS_SUCCESS / GET_TODOS_REQUEST
    draft[requestName + '_FAILURE'] = requestState === 'FAILURE';
  });
};

export default errorReducer;
